<ng-container *ngIf="pick?.combination as c">
<div class="finalize-appointment">
  <h5>{{ 'SUMMARY.PICKED_SLOT' | translate }}:</h5>
  <a class="pp-link" [routerLink]="['../../../../izberi-termin']">{{ 'SUMMARY.CHANGE' | translate }}</a>
   <ion-grid  class="ion-no-padding" [routerLink]="['../../../../izberi-termin']">

        <ion-row class="ion-no-padding" *ngIf="!hidePartySize">
          <ion-col size="8"><h4>{{ c.start | momentDate:"fullDate":undefined:translateService.currentLang }}</h4></ion-col>
          <ion-col size="4" class="ion-text-end"><h4>{{ 'SUMMARY.FOR' | translate }} {{ pick.partySize }} {{ pick.partySize | i18nPlural : { '=1': 'PERSON_PLURAL.PERSON_1', '=2': 'PERSON_PLURAL.PERSONS_2', '=3': 'PERSON_PLURAL.PERSONS_3', '=4': 'PERSON_PLURAL.PERSONS_4', 'other': 'PERSON_PLURAL.PERSONS_5'} | translate }}</h4></ion-col>
      </ion-row>
  </ion-grid>
  
  <h5 class="-time">{{ 'SUMMARY.START_AT' | translate }}: {{ c.start | momentDate:"shortTime":undefined:translateService.currentLang }}</h5>
  <h4 class="-address"><span *ngIf="real?.provider.brandName !== real?.name">{{ real?.provider.brandName }} </span>{{ real?.name }}</h4>
  <h5 class="-time">{{ real?.address }}</h5>
</div>


<ion-list>

  <!--ng-container *ngFor="let p of c.products; index as i;"-->
    
    <!--ion-item-divider *ngIf="c.products.length > 1">
      <ion-label>
        {{i+1}}. meni 
      </ion-label>
    </ion-item-divider-->

    <ion-item color="none" lines="none" class="finalize-appointment__item" *ngFor="let p of c.products; index as j;">

      <ion-grid  class="ion-no-padding">
        
        <ion-row class="ion-no-padding ion-align-items-center">
          <ion-col size="8" class="finalize-appointment__item-lead">Vegi meni</ion-col>
          <ion-col size="2"></ion-col>
          <ion-col size="2">
            <!--ion-icon class="close"></ion-icon-->
          </ion-col>
        </ion-row>
        <ion-row class="ion-align-items-center ion-no-padding">
          <ion-col size="4" class="col--main">
            <div class="img-container">
              text 1
            </div>
            <span>text 2</span>
          </ion-col>
          <ion-col size="3">text 2</ion-col>
          <ion-col size="2">text 4</ion-col>
          <ion-col size="3" class="ion-text-end">{{ p.price.amount | currency: p.price.currency }}</ion-col>
        </ion-row>

       <!--   <ion-col size="5"  class="ion-no-padding">
            {{ pick.attendees[i].services[j].name }}
          </ion-col>

          <ion-col class="ion-no-padding" size="2" *ngIf="getEmployeeFromEmployeeHref( s.employeeHref ) as e">
            <div><img style="max-height: 30px" [src]= "e.avatar | ppImage"></div>
            <div>{{ e.name }}</div>
            <div>{{ e.title }}</div>
          </ion-col>

           <ion-col class="ion-no-padding ion-text-end" ng-show="this.currentState == 'review'">
            {{ ( s.durationInSeconds / 60 ) | number:'1.0-0' }}'
          </ion-col>

          <ion-col class="ion-no-padding ion-text-end" ng-show="this.currentState == 'review'">
            {{ s.price.amount | currency: s.price.currency }}
          </ion-col>   

        </ion-row>-->
      </ion-grid>

    </ion-item>

    <!--ion-item class="ion-no-padding" *ngIf="c.attendees.length > 1">
      <ion-grid  class="ion-no-padding">
        <ion-row>
          <ion-col size="7">
            Skupaj za {{i+1}}. osebo
          </ion-col>
           <ion-col class="ion-text-end">
            {{ ( a.durationInSeconds / 60 ) | number:'1.0-0' }}'
          </ion-col>

          <ion-col class="ion-text-end">
            {{ a.total.amount | currency: a.total.currency }}
          </ion-col>   

        </ion-row>
      </ion-grid>
    </ion-item-->

 
    <ion-item *ngIf="false" color="none" lines="none" class="finalize-appointment__item finalize-appointment__item--total">
      <ion-grid  class="ion-no-padding">
        <ion-row class="ion-align-items-center ion-no-padding">
          <ion-col size="4" class="col--main">
            <span>{{ 'SUMMARY.TOTAL' | translate }}</span>
          </ion-col>
          <ion-col size="3"></ion-col>
          <ion-col size="2"></ion-col>
          <ion-col size="3" class="ion-text-end">{{ pick.total | currency: 'EUR' }}</ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>

  <!--/ng-container-->

</ion-list>